import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const createFAQAction = createAsyncThunk(
    'create-FAQ',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/support-server/api/support-knowladge`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const createFAQSlice = createSlice({
    name: 'create-FAQ',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(createFAQAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(createFAQAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(createFAQAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const createFAQReducer = createFAQSlice.reducer